import React, { useState } from 'react'
import BaseButton from '../../../components/common/BaseButton'
import type { NarrativeOcgSeverity, NarrativeOcgValidationHint } from '../types'
import { getIssueCount } from '../utils/issueDetails'
import { NarrativeOcgIssueDetailsDialog } from './NarrativeOcgIssueDetailsDialog'

export const NarrativeOcgValidationBadges = ({
  validationHint,
  onFloatingWindowInteraction,
  isMobile = false,
}: {
  validationHint?: NarrativeOcgValidationHint
  onFloatingWindowInteraction?: (isOpen?: boolean) => void
  isMobile?: boolean
}) => {
  const [activeSeverity, setActiveSeverity] = useState<
    NarrativeOcgSeverity | undefined
  >()
  const errorCount = getIssueCount(validationHint, 'error')
  const warningCount = getIssueCount(validationHint, 'warning')

  if (!validationHint?.visible || (!errorCount && !warningCount)) return null

  return (
    <>
      <div className="narrative-ocg-badges inline-flex items-center gap-1.5">
        {errorCount ? (
          <BaseButton
            className="narrative-ocg-badge narrative-ocg-badge--error inline-flex h-[22px] !min-h-0 cursor-pointer items-center justify-center whitespace-nowrap !rounded border border-solid px-[7px] py-[3px] text-[10px] font-normal leading-[1.6] tracking-[0.5px] shadow-none backdrop-blur-[3px]"
            fillMode="flat"
            onClick={event => {
              onFloatingWindowInteraction?.()
              event.stopPropagation()
              setActiveSeverity('error')
            }}
            themeColor="base"
            type="button"
          >
            Error ({errorCount})
          </BaseButton>
        ) : null}
        {warningCount ? (
          <BaseButton
            className="narrative-ocg-badge narrative-ocg-badge--warning inline-flex h-[22px] !min-h-0 cursor-pointer items-center justify-center whitespace-nowrap !rounded border border-solid px-[7px] py-[3px] text-[10px] font-normal leading-[1.6] tracking-[0.5px] shadow-none"
            fillMode="flat"
            onClick={event => {
              onFloatingWindowInteraction?.()
              event.stopPropagation()
              setActiveSeverity('warning')
            }}
            themeColor="base"
            type="button"
          >
            Warning ({warningCount})
          </BaseButton>
        ) : null}
      </div>
      {activeSeverity ? (
        <NarrativeOcgIssueDetailsDialog
          validationHint={validationHint}
          severity={activeSeverity}
          onFloatingWindowInteraction={onFloatingWindowInteraction}
          onClose={() => setActiveSeverity(undefined)}
          isMobile={isMobile}
        />
      ) : null}
    </>
  )
}
